<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
            <a-form-item
            label="记录编号"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
            v-if="this.id"
          >
            <a-input
              placeholder="请输入记录编号"
              v-decorator="[
          'number',
          {rules: [{ required: true, message: '请输入记录编号!' }],initialValue:info.id}
        ]"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item
            label="会员编号"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
          >
            <a-input
              placeholder="请输入会员编号"
              v-decorator="[
          'number',
          {rules: [{ required: true, message: '请输入会员编号!' }],initialValue:info.id}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="规则"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
          >
           <a-select placeholder="请选择" allowClear>
              <a-select-option value="0">系统</a-select-option>
              <a-select-option value="1">人工</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="11"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
          >
           <a-radio-group
              @change="onChange"
              v-decorator="[
          'sex',
          {rules: [],initialValue:info.sex}
        ]"
            >
              <a-radio :value="1">加</a-radio>
              <a-radio :value="2">减</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item
            label="变动积分"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
          >
            <a-input
              placeholder="请输入变动积分"
              v-decorator="[
          'number',
          {rules: [{ required: true, message: '请输入变动积分!' }],initialValue:info.id}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
      <!--选择服务项目--->
      <a-modal title="选择服务项目" v-model="service.visible" width="80%" :footer="false" destroyOnClose>
        <choseService @callbackMethod="getservice" :ids="serviceIds" />
      </a-modal>
      <!--选择擅长项目--->
      <a-modal title="选择擅长项目" v-model="good.visible" width="80%" :footer="false" destroyOnClose>
        <choseService @callbackMethod="getgood" :ids="goodIds" />
      </a-modal>
      <!--查看排班--->
      <a-modal title="排班表" v-model="schedule.visible" width="80%" :footer="false" destroyOnClose>
        <schedulelist @callbackMethod="getschedule" :list="schedule.list" />
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
var that;
import choseService from "./choseService.vue";
import schedulelist from "./schedulelist.vue";
export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    },
    id: 0
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        number: "",
        startTime: "",
        endTime: ""
      },
      servicelists: [],
      serviceNames: [],
      serviceIds: [],
      goodlists: [],
      goodNames: [],
      goodIds: [],
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      previewVisible: false,
      previewImage: "",
      uploadImg: [],
      service: {
        //服务项目
        visible: false
      },
      good: {
        //擅长项目
        visible: false
      },
      schedule: {
        //排班
        visible: false,
        list: ""
      }
    };
  },
  components: {
    choseService,
    schedulelist
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      if (this.id) {
        //编辑
        this.getInfo();
      }
      if (!this.type) {
        this.dis = true;
      }
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    /**数据回显 */
    getInfo() {
      this.isloading = true;
      this.$api.member.expert
        .getById(this.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
            if (res.data.img) {
              var picurlArr = res.data.img.split(",");
              picurlArr.forEach(function(item, index) {
                that.fileList.push({
                  name: item,
                  response: { data: { name: item, path: item } },
                  uid: item,
                  thumbUrl: item
                });
              });
            }
            if (res.data.schedule && res.data.schedule != "undefined") {
              this.schedule.list = res.data.schedule;
            }
            //可服务项目
            var serviceProject = JSON.parse(res.data.serviceProject);
            this.servicelists = [];
            this.serviceNames = [];
            this.serviceIds = [];
            serviceProject.forEach(function(item, index) {
              that.servicelists.push({
                name: item.name,
                id: item.id,
                img: item.img
              });
              that.serviceNames.push(item.name);
              that.serviceIds.push(item.id);
            });
            that.info.serviceNames = this.serviceNames.join(",");
            //擅长项目
            var majorProject = JSON.parse(res.data.majorProject);
            this.goodlists = [];
            this.goodNames = [];
            this.goodIds = [];
            majorProject.forEach(function(item, index) {
              that.goodlists.push({
                name: item.name,
                id: item.id
              });
              that.goodNames.push(item.name);
              that.goodIds.push(item.id);
            });
            that.info.goodNames = this.goodNames.join(",");
            this.info.recommend = this.$commen.changeIntBoolean(res.data.recommend);
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    /**选择可服务项目 */
    choseService() {
      this.service.visible = true;
    },
    getservice(data) {
      this.service.visible = false;
      this.servicelists = [];
      this.serviceNames = [];
      this.serviceIds = [];
      data.forEach(function(item, index) {
        that.servicelists.push({
          name: item.name,
          id: item.id,
          img: item.img
        });
        that.serviceNames.push(item.name);
        that.serviceIds.push(item.id);
      });
      that.info.serviceNames = this.serviceNames.join(",");
      this.form.setFieldsValue({
        serviceNames: this.serviceNames.join(",")
      });
    },
    /**选择擅长 */
    choseGood() {
      this.good.visible = true;
    },
    getgood(data) {
      this.good.visible = false;
      this.goodlists = [];
      this.goodNames = [];
      this.goodIds = [];
      data.forEach(function(item, index) {
        that.goodlists.push({
          name: item.name,
          id: item.id
        });
        that.goodNames.push(item.name);
        that.goodIds.push(item.id);
      });
      that.info.goodNames = this.goodNames.join(",");
      this.form.setFieldsValue({
        goodNames: this.goodNames.join(",")
      });
    },
    /**查看排班 */
    handleSchedule() {
      this.schedule.visible = true;
    },
    getschedule(data) {
      this.schedule.visible = false;
      var schedules = {};
      data.forEach(function(item, index) {
        var thisData = {};
        thisData["am"] = item.am;
        thisData["pm"] = item.pm;
        schedules[item.time] = thisData;
      });
      this.schedule.list = JSON.stringify(schedules);
      //console.log(schedules);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.uploadImg = [];
          this.fileList.forEach(function(item, index) {
            that.uploadImg.push(item.response.data.path);
          });
          if (this.id) {
            //修改
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.member.expert
              .updateById(
                that.id,
                that.uploadImg.join(","),
                values.employedTime,
                values.appointmentCount,
                values.appointPrice,
                values.caseCount,
                values.supportCount,
                that.serviceIds.join(","),
                that.goodIds.join(","),
                values.introduce,
                that.schedule.list ? that.schedule.list : "",
                values.recommend
                  ? this.$commen.changeBooleanInt(values.recommend)
                  : this.$commen.changeBooleanInt(this.info.recommend)
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },

    onRangeChange(value, dateString) {
      this.info.startTime = dateString[0];
      this.info.endTime = dateString[1];
    },
    onCheckboxChange(e) {
      this.info.checked = e.target.checked;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
      if (info.file.status) {
        this.fileList = info.fileList;
      }
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.scheduleBtn {
  color: #1890ff;
  cursor: pointer;
}
</style>